import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Link } from "@/components/Interface/Link/Link";
import { Modal } from "@/components/Interface/Modal/Modal";

const ZONES = [
  { key: "ZONE1", hasCountriesList: true, titlePrefix: "Zone " },
  { key: "ZONE2", hasCountriesList: true, titlePrefix: undefined },
  { key: "ZONE3", hasCountriesList: true, titlePrefix: undefined },
  { key: "ZONE4", hasCountriesList: false, titlePrefix: undefined },
] as const;

/** A modal that lists all countries per roaming zone, grouped by zone. */
export const CountrylistDialog = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation("portal");

  return (
    <>
      <Link type="button" size="sm" onClick={() => setIsOpen(true)}>
        {t("common.roaming.countryList")}
      </Link>

      {isOpen && (
        <Modal
          title={t("common.roaming.dialog.title")}
          onClose={() => setIsOpen(false)}
          variant="dark"
        >
          <div className="text-foreground-primary-inverse">
            {ZONES.map(({ key, hasCountriesList, titlePrefix }) =>
              hasCountriesList ? (
                <div key={key}>
                  <h3 className="mb-3 font-semibold">
                    {(titlePrefix ?? "") + t(`common.roaming.zones.${key}`)}
                  </h3>
                  <hr className="mb-4 border-foreground-primary-inverse/20" />
                  <p className="mb-8 text-body-base">
                    {t(`common.roaming.zones.countries.${key}`)}
                  </p>
                </div>
              ) : (
                <p key={key} className="text-body-sm">
                  {t(`common.roaming.zones.${key}`)}
                </p>
              ),
            )}
          </div>
        </Modal>
      )}
    </>
  );
};
